import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  size?: number;
  className?: string;
};

const AmazonIcon = ({ size, className }: Props) => (
  <Root
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    version="1.1"
    width={size}
    height={size}
    className={className}
  >
    <g data-name="\u30B0\u30EB\u30FC\u30D7 336">
      <path data-name="\u9577\u65B9\u5F62 808" fill="#fff" d="M0 0h512v512H0z" />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 335">
        <path
          data-name="\u30D1\u30B9 1046"
          d="M365.116 204.682c0 15.663.563 31.232-.188 46.895-.75 17.82 4.689 33.108 15.944 46.613a60.062 60.062 0 013.658 4.877c4.033 6.1 3.283 10.317-2.251 15.006-11.818 9.942-23.541 19.977-35.359 29.919-7.034 5.909-11.442 5.815-18.57 0-9.567-7.785-17.07-17.351-23.729-27.574-1.594-2.439-2.439-2.345-4.408-.469-11.818 11.536-24.292 22.228-40.142 27.574-24.479 8.347-49.333 9.66-73.906.938-23.635-8.441-37.8-25.886-43.049-50.177-5.815-27.105-2.814-52.9 13.881-75.876 12.662-17.351 30.2-27.574 50.365-33.858 20.821-6.378 42.3-8.816 63.871-10.973 6.1-.657 12.1-1.219 18.2-1.782 1.5-.094 2.814-.281 2.72-2.251-.188-9.942.844-20.071-1.5-29.825-3-12.474-11.161-19.79-23.635-22.509a48.464 48.464 0 00-26.355 1.5c-13.131 4.5-21.29 13.6-24.573 27.105-1.782 7.409-5.252 10.035-12.474 9.285a74370.632 74370.632 0 01-46.051-4.783c-6.284-.657-9.567-5.44-8.253-11.536 7.967-38.923 33.478-60.776 70.243-70.816 28.231-7.691 56.836-8.16 85.161-.188 22.791 6.378 41.924 17.632 52.616 39.954 6.1 12.662 7.5 26.355 7.691 40.048.188 17.539 0 35.265.094 52.9zm-72.968 29.262c0-4.689-.188-9.379.094-14.068.188-2.907-.844-3.939-3.752-3.658-7.128.657-14.35.75-21.478 1.688-12.474 1.594-24.667 4.689-34.8 12.568-14.725 11.536-17.82 27.293-15.382 45.019 2.907 20.821 21.478 32.357 41.361 25.417 13.506-4.69 21.759-14.631 27.48-27.105 6.008-12.662 6.477-26.261 6.477-39.861z"
          fill="#050606"
        />
        <path
          data-name="\u30D1\u30B9 1047"
          d="M257.446 445.627c-71.561-.469-135.807-18.852-193.863-57.587a310.611 310.611 0 01-33.764-25.98 18.016 18.016 0 01-2.626-2.72c-1.032-1.407-1.782-3.1-.563-4.783a3.779 3.779 0 015.065-1.219c4.127 1.97 8.066 4.127 12.1 6.19a457.957 457.957 0 00116.677 42.487 464.55 464.55 0 00112.172 10.786 449.754 449.754 0 00156.441-32.545 44.565 44.565 0 017.5-2.626c3.564-.656 7.128-.188 8.722 3.658 1.5 3.564-.469 6.378-3.1 8.629a60.355 60.355 0 01-6.19 4.314c-32.357 21.009-67.81 34.515-105.326 42.862a346.756 346.756 0 01-73.245 8.534z"
          fill="#ff8900"
        />
        <path
          data-name="\u30D1\u30B9 1048"
          d="M437.996 362.061c-10.786-.094-21.478 1.313-32.17 2.439-2.063.188-4.408.75-5.346-1.5-1.125-2.532 1.032-4.033 2.814-5.252 13.318-8.816 28.231-12.286 43.893-13.131 10.786-.657 21.478-.188 31.982 3 4.783 1.407 7.128 4.221 7.034 9.1-.563 26.073-9.285 48.771-28.137 67.247a19.782 19.782 0 01-2.157 1.782c-1.688 1.219-3.752 2.345-5.534.844-1.688-1.407-.75-3.47 0-5.158 5.534-13.787 11.161-27.48 13.881-42.205a38.172 38.172 0 00.563-5.534c.094-6.1-2.063-8.722-8.066-10.223-6.288-1.69-12.572-1.409-18.757-1.409z"
          fill="#ff8900"
        />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')({ fill: 'currentColor' });

export default AmazonIcon;
